import { EventChooseLanguageComponent } from '@shared/models/components/event-choose-language';
import {
  LanguageRequestData,
  QuestionAnswerRequest,
} from '@shared/models/question-answer-request';

export const createLanguageObject = (
  responseId: string,
  language: string,
): QuestionAnswerRequest => {
  const languageRequestData: LanguageRequestData = {
    $type: 'languageResponseData',
    questionId: '',
    language,
  };
  return {
    responseId,
    type: 'CHOOSE_LANGUAGE',
    data: languageRequestData,
  };
};

export const mapLanguageOptions = (
  languageComponent: EventChooseLanguageComponent,
): { value: string; label: string; src: string }[] => {
  return (
    languageComponent.languages.map((i) => ({
      label: i.localizedTitle,
      value: i.code,
      src: 'assets/flags/' + i.flag,
    })) || []
  );
};

export const isObject = (value: any): boolean => {
  return typeof value === 'object' && value !== null;
};

export function getLocaleFormattedDate(
  isoDate: string,
  locale: string,
): string {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const date = new Date(isoDate);
  const formatter = new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: timezone,
  });
  return formatter.format(date);
}

export const updateTextDirection = (language: string) => {
  const rtlLanguageCodes = [
    'ar-SA',
    'he-IL',
    'ku-TR',
    'fa-IR',
    'sd-PK',
    'prs-AF',
    'ku-Arab',
    'ar-AE',
    'ar-QA',
    'ps-AF',
    'ur-PK',
  ];
  document.documentElement.setAttribute(
    'dir',
    rtlLanguageCodes.includes(language) ? 'rtl' : 'ltr',
  );
};
